import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { useI18n } from "@/shared/hooks";
import { useUnits } from "@/contexts/classified";
export const testId = "cdp-sections-units-header";
export const Header = () => {
    const { t } = useI18n();
    const { projectName, availability } = useUnits() || {};
    return (_jsxs(_Fragment, { children: [_jsx(Box, { as: "h2", marginTop: "0", marginBottom: "spacing.8", testId: `${testId}-title`, typography: {
                    "breakpoint.base": "typography.headline.24.bold",
                    "breakpoint.lg": "typography.headline.22.bold",
                }, children: t("pdpSeeker_available_units_title") }), _jsxs(Box, { as: "h3", marginTop: 0, marginBottom: "spacing.32", children: [_jsxs(Box, { as: "span", typography: "typography.body.16.bold", display: { "breakpoint.base": "block", "breakpoint.lg": "inline" }, testId: `${testId}-projectName`, children: [projectName, ":", " "] }), _jsx(Box, { as: "span", typography: "typography.body.16.regular", color: "color.content.subdued.default", testId: `${testId}-availability`, children: availability })] })] }));
};
